var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-add-user';
                    var viewUrl = 'sprite.svg#view-icon-add-user';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };